import { createSelector } from "@reduxjs/toolkit";

import { formatNavigatorLocation } from "@src/store/slices/experienceBuilder/common/utils/formatNavigatorLocation";
import { orgBaseUrl } from "@src/store/slices/experienceBuilder/common/utils/resolveFullUrl";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";
import { getOrganization } from "@src/store/slices/organization";

/**
 * What the Navigator displays for the current preview location: the pathname
 * while on the org's own store, the full URL once the preview has navigated to
 * a different domain. `undefined` before the preview is pointed anywhere.
 *
 * See `formatNavigatorLocation` for the rule.
 */
export const getDisplayLocation = createSelector(
  experienceBuilderSlice.selectors.getLastLocation,
  getOrganization,
  (lastLocation, org): string | undefined =>
    lastLocation
      ? formatNavigatorLocation(lastLocation, orgBaseUrl(org))
      : undefined
);
